import React from "react";
import getShareholderStore from "../../../stores/shareholder-store";
import Et3BarChart from "../../../core/et3-chart/Et3BarChart";
import { withLiteObserverAndTheme } from "../../../core/et3-enhanced-render";
import Et3Margin from "../../../core/et3-ui/ET3Margin";
import i18n from "../../../constants/i18n";

const ShareholderData = withLiteObserverAndTheme(() => {
  const shareholderStore = getShareholderStore();
  const datesToShow = shareholderStore.datesToShow.get();
  const totalUsersData = shareholderStore.totalUsersData.get();
  const newUsersData = shareholderStore.newUsersData.get();
  const totalConversationData = shareholderStore.totalConversationData.get();
  const newConversationData = shareholderStore.newConversationData.get();
  const totalMessagesData = shareholderStore.totalMessagesData.get();
  const newMessagesData = shareholderStore.newMessagesData.get();
  const salesData = shareholderStore.salesData.get();
  const marketingExpensesData = shareholderStore.marketingExpensesData.get();
  const shouldShow = shareholderStore.shouldShow.get();

  return (
    shouldShow && (
      <React.Fragment>
        <Et3BarChart
          title={i18n.get("TOTAL_USERS")}
          dataLabels={datesToShow}
          values={totalUsersData}
        />
        <Et3Margin top={30} bottom={0} left={0} right={0} />
        <Et3BarChart
          title={i18n.get("NEW_USERS")}
          dataLabels={datesToShow}
          values={newUsersData}
        />
        <Et3Margin top={30} bottom={0} left={0} right={0} />
        <Et3BarChart
          title={i18n.get("TOTAL_CONVERSATIONS")}
          dataLabels={datesToShow}
          values={totalConversationData}
        />
        <Et3Margin top={30} bottom={0} left={0} right={0} />
        <Et3BarChart
          title={i18n.get("NEW_CONVERSATIONS")}
          dataLabels={datesToShow}
          values={newConversationData}
        />
        <Et3Margin top={30} bottom={0} left={0} right={0} />
        <Et3BarChart
          title={i18n.get("TOTAL_MESSAGES")}
          dataLabels={datesToShow}
          values={totalMessagesData}
        />
        <Et3Margin top={30} bottom={0} left={0} right={0} />
        <Et3BarChart
          title={i18n.get("NEW_MESSAGES")}
          dataLabels={datesToShow}
          values={newMessagesData}
        />
        <Et3Margin top={30} bottom={0} left={0} right={0} />
        <Et3BarChart
          title={i18n.get("SALES_USD")}
          dataLabels={datesToShow}
          values={salesData}
        />
        <Et3Margin top={30} bottom={0} left={0} right={0} />
        <Et3BarChart
          title={i18n.get("MARKETING_EXPENSES_USD")}
          dataLabels={datesToShow}
          values={marketingExpensesData}
        />
      </React.Fragment>
    )
  );
});
export default ShareholderData;
